import '@hapana/shared/utils/type-defs.util'

/** @type {Styles} */
export const styles = {
  dialogContent: {
    padding: 3,
    paddingTop: 1,
  },
  search: {
    width: '100%',
    margin: -1,
    marginBottom: -1.5,
  },
  bandDivider: {
    height: 8,
    backgroundColor: 'gray.3',
    marginX: -3,
    marginY: 1.5,
  },
  tableSection: {
    display: 'flex',
    flexDirection: 'column',
    gap: 2,
  },
  tableWrapper: {
    borderStyle: 'solid',
    borderWidth: 1,
    borderColor: 'gray.12',
    borderRadius: 1,
    overflow: 'hidden',
  },
  stateContainer: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    minHeight: 200,
  },
}
